export const TOGGLE_DARK_THEME = "TOGGLE_DARK_THEME";
export const CHANGE_COLOR_THEME = "CHANGE_COLOR_THEME";
export const TOGGLE_COLOR_PANALE = "TOGGLE_COLOR_PANALE";

export const TOGGLE_NAVBAR_OPEN = "TOGGLE_NAVBAR_OPEN";

export const GET_DATA_FROM_DATABASE = "GET_DATA_FROM_DATABASE";
